import { call, put, takeEvery } from "redux-saga/effects";

import {
  ADD_NEW_QUESTION,
  ADD_NEW_WORKFLOW,
  BULK_IMPORT_QUESTIONS,
  DELETE_WORKFLOW,
  GET_CSV_QUESTION_STATUS,
  GET_QUESTIONS_LIST,
  GET_QUESTION_DETAILS,
  GET_SAMPLE_CSV_QUESTION,
  GET_WORKFLOW_LIST,
  GET_WORKFLOW_OPTIONS_LIST,
  TOGGLE_QUESTION,
  UPDATE_QUESTION_DETAILS,
  UPDATE_WORKFLOW_DETAILS,
} from "./actionTypes";

import {
  addNewQuestionFailed,
  addNewQuestionSuccess,
  addNewWorkflowFailed,
  addNewWorkflowSuccess,
  bulkImportQuestionsFailed,
  bulkImportQuestionsSuccess,
  deleteWorkflowFailed,
  deleteWorkflowSuccess,
  getCsvQuestionStatusFailed,
  getCsvQuestionStatusSuccess,
  getQuestionDetailsFailed,
  getQuestionDetailsSuccess,
  getQuestionsListFailed,
  getQuestionsListSuccess,
  getSampleCsvQuestionFailed,
  getSampleCsvQuestionSuccess,
  getWorkFlowOptionsFailed,
  getWorkFlowOptionsSuccess,
  getWorkflowListFailed,
  getWorkflowListSuccess,
  toggleQuestionFailed,
  toggleQuestionSuccess,
  updateQuestionDetailsFailed,
  updateQuestionDetailsSuccess,
  updateWorkFlowDetailsFailed,
  updateWorkFlowDetailsSuccess,
} from "./actions";

import {
  deleteCall,
  getCareerInfo,
  postCall,
  putCall,
  updateCompanyStatus,
} from "../../../helpers/fakebackend_helper";

//restapi end point
import * as constClass from "../../../common/constant/constantURL";
import { verifyData } from "../../../pages/Common/CommonFunctions/commonFunctions";

function* getQuestionsListHandler(dat) {
  try {
    let data = dat.payload;

    var url =
      constClass.REST_API_QUESTION_BANK +
      `?pageNumber=${data.pageNumber}&pageSize=${data.pageSize}` +
      (verifyData(data.searchKeyword) ? `&keyword=${data.searchKeyword}` : "");
    var responsJSON = yield call(getCareerInfo, url);
    yield put(getQuestionsListSuccess(responsJSON));
  } catch (error) {
    yield put(getQuestionsListFailed(error));
  }
}

function* addNewQuestionHandler(dat) {
  try {
    let data = dat.payload;

    var url = constClass.REST_API_QUESTION_BANK;
    var responsJSON = yield call(postCall, url, data);
    yield put(addNewQuestionSuccess(responsJSON));
  } catch (error) {
    yield put(addNewQuestionFailed(error));
  }
}

function* getWorkFlowHandler(dat) {
  try {
    let data = dat.payload;

    var url =
      constClass.REST_API_WORKFLOW +
      `?pageNumber=${data.pageNumber}&pageSize=${data.pageSize}` +
      (verifyData(data.searchKeyword) ? `&keyword=${data.searchKeyword}` : "");
    var responsJSON = yield call(getCareerInfo, url);
    yield put(getWorkflowListSuccess(responsJSON));
  } catch (error) {
    yield put(getWorkflowListFailed(error));
  }
}

function* getQuestionDetailsHandler(dat) {
  try {
    let data = dat.payload;

    var url = constClass.REST_API_QUESTION_BANK + `/${data}`;
    var responsJSON = yield call(getCareerInfo, url);
    yield put(getQuestionDetailsSuccess(responsJSON));
  } catch (error) {
    yield put(getQuestionDetailsFailed(error));
  }
}

function* updateQuestionDetailsHandler(dat) {
  try {
    let data = dat.payload;

    var url = constClass.REST_API_QUESTION_BANK + `/${data.id}`;
    var responsJSON = yield call(putCall, url, data.data);
    yield put(updateQuestionDetailsSuccess(responsJSON));
  } catch (error) {
    yield put(updateQuestionDetailsFailed(error));
  }
}

function* toggleQuestionHandler(dat) {
  try {
    let data = dat.payload;

    var url = constClass.REST_API_QUESTION_BANK + `/${data.id}`;
    var responsJSON = yield call(updateCompanyStatus, url, data.data);
    yield put(toggleQuestionSuccess(responsJSON));
  } catch (error) {
    yield put(toggleQuestionFailed(error));
  }
}

function* getWorkFlowOptionsHandlder(dat) {
  try {
    var url = constClass.REST_API_WORKFLOW + `/stage/options`;
    var responsJSON = yield call(getCareerInfo, url);
    yield put(getWorkFlowOptionsSuccess(responsJSON));
  } catch (error) {
    yield put(getWorkFlowOptionsFailed(error));
  }
}

function* addWorkflowHandler(dat) {
  try {
    let data = dat.payload;
    var url = constClass.REST_API_WORKFLOW;
    var responsJSON = yield call(postCall, url, data);
    yield put(addNewWorkflowSuccess(responsJSON));
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.message ||
      "Failed to add workflow.";
    yield put(addNewWorkflowFailed(message));
  }
}

function* updateWorkFlowHandler(dat) {
  try {
    let data = dat.payload;
    var url = constClass.REST_API_WORKFLOW + `/${data.id}`;
    var responsJSON = yield call(putCall, url, data.data);
    yield put(updateWorkFlowDetailsSuccess(responsJSON));
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.message ||
      "Failed to update workflow.";
    yield put(updateWorkFlowDetailsFailed(message));
  }
}

function* getCsvHandler(dat) {
  try {
    let data = dat.payload;

    var url = constClass.REST_API_QUESTION_BANK + `/${data.type}/sampleCSV`;
    var responsJSON = yield call(getCareerInfo, url);
    yield put(getSampleCsvQuestionSuccess(responsJSON));
  } catch (error) {
    yield put(getSampleCsvQuestionFailed(error));
  }
}

function* getCsvQuestionStatusHandler(dat) {
  try {
    let data = dat.payload;

    var url = constClass.REST_API_QUESTION_BANK + `/${data.id}/status`;
    var responsJSON = yield call(getCareerInfo, url);
    yield put(getCsvQuestionStatusSuccess(responsJSON));
  } catch (error) {
    yield put(getCsvQuestionStatusFailed(error));
  }
}

function* bulkImportQuestionsHandler(dat) {
  try {
    let data = dat.payload;

    var url = constClass.REST_API_QUESTION_BANK + `/${data.type}/importCSV`;
    var responsJSON = yield call(postCall, url, data.data);
    yield put(bulkImportQuestionsSuccess(responsJSON));
  } catch (error) {
    yield put(bulkImportQuestionsFailed(error));
  }
}

function* deleteWorkflowHandler(dat) {
  try {
    let data = dat.payload;
    var url = constClass.REST_API_WORKFLOW + `/${data.id}`;
    var responsJSON = yield call(deleteCall, url);
    yield put(deleteWorkflowSuccess(responsJSON));
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.message ||
      "Failed to delete workflow.";
    yield put(deleteWorkflowFailed(message));
  }
}

function* questionsSaga() {
  yield takeEvery(GET_QUESTIONS_LIST, getQuestionsListHandler);
  yield takeEvery(GET_WORKFLOW_LIST, getWorkFlowHandler);
  yield takeEvery(ADD_NEW_QUESTION, addNewQuestionHandler);
  yield takeEvery(GET_QUESTION_DETAILS, getQuestionDetailsHandler);
  yield takeEvery(UPDATE_QUESTION_DETAILS, updateQuestionDetailsHandler);
  yield takeEvery(TOGGLE_QUESTION, toggleQuestionHandler);
  yield takeEvery(GET_WORKFLOW_OPTIONS_LIST, getWorkFlowOptionsHandlder);
  yield takeEvery(ADD_NEW_WORKFLOW, addWorkflowHandler);
  yield takeEvery(UPDATE_WORKFLOW_DETAILS, updateWorkFlowHandler);
  yield takeEvery(GET_SAMPLE_CSV_QUESTION, getCsvHandler);
  yield takeEvery(GET_CSV_QUESTION_STATUS, getCsvQuestionStatusHandler);
  yield takeEvery(BULK_IMPORT_QUESTIONS, bulkImportQuestionsHandler);
  yield takeEvery(DELETE_WORKFLOW, deleteWorkflowHandler);
}

export default questionsSaga;
